import axios from 'axios'

export default {
    initialize: function () {
        window.ptId = getPtId()
        window.clientId = parseInt(getParamValue('client_id'))
        window.openedByApp = getParamValue('app')
        window.apiDev = getParamValue('dev')
        window.language = getLanguage()
        window.screenBackgroundColor = getParamValue('screen_background')
        window.screenBackgroundColor = window.screenBackgroundColor ? window.screenBackgroundColor : getParamValue('background')
        window.apiKey = getApiKey()
        checkBackground()

        if (window.openedByApp == 'true') {
            window.openedByApp = true
        } else {
            window.openedByApp = false
        }

        function getParamValue(param) {
            const queryString = window.location.search
            const urlParams = new URLSearchParams(queryString)
            return urlParams.get(param)
        }

        function getPtId() {
            const ptId = getParamValue('pt_id')
            const pt = getParamValue('pt')
            if (ptId) {
                return parseInt(ptId)
            }
            if (pt) {
                if (PTS_IDS && PTS_IDS[pt]) {
                    return PTS_IDS[pt]
                } else {
                    return pt
                }
            }
            if (PTS_TAGS) {
                const ptTag = PTS_TAGS.find(function (tag) {
                    return window.location.href.indexOf(tag.key) > -1
                })
                if (ptTag) {
                    return ptTag.id
                }
            }
            return ptId
        }

        function getLanguage() {
            const lng = getParamValue('lng')
            if (lng) {
                return lng
            } else {
                return 'pt'
            }
        }

        function getApiKey() {
            if (PTS_TAGS) {
                const ptTag = PTS_TAGS.find(function (tag) {
                    return window.location.href.indexOf(tag.key) > -1 || tag.id === window.ptId
                })
                if (ptTag && ptTag.api) {
                    return ptTag.api
                }
            }
            return 'common'
        }

        function checkBackground() {
            if (window.screenBackgroundColor) {
                if (document.documentElement && document.documentElement.style) {
                    document.documentElement.style.backgroundColor = '#' + window.screenBackgroundColor
                }
                if (document.body && document.body.style) {
                    document.body.style.backgroundColor = '#' + window.screenBackgroundColor
                }
            }
        }
    },
    updateAuthorization: function () {
        const user = JSON.parse(process.env.VUE_APP_EMAIL).pt
        const password = JSON.parse(process.env.VUE_APP_PASSWORD).pt
        axios.defaults.authorization = 'Basic ' + window.btoa(user + ':' + password)
    },
    refreshEnums: function (enums) {
        try {
            const str = this.getStrings()
            if (str) {
                for (const key in enums) {
                    if (enums[key]) {
                        for (let i = 0; i < enums[key].length; i++) {
                            if (enums[key][i].label) {
                                enums[key][i].label = str[enums[key][i].label] ? str[enums[key][i].label] : enums[key][i].label
                            }
                        }
                    }
                }
            }
        } catch (error) { }
        localStorage.setItem('enums', JSON.stringify(enums))
    },
    getEnums: function () {
        const enums = localStorage.getItem('enums')
        return enums ? JSON.parse(enums) : {}
    },
    getContentsConfig: function () {
        const enums = this.getEnums()
        if (enums && enums.contents_config) {
            return enums.contents_config
        } else {
            return []
        }
    },
    getContentTypes: function () {
        const enums = this.getEnums()
        if (enums && enums.content_types) {
            return enums.content_types
        } else {
            return []
        }
    },
    getContentType: function () {
        const enums = this.getEnums()
        if (enums && enums.content_type) {
            return enums.content_type
        } else {
            return []
        }
    },
    getContentNotes: function () {
        const enums = this.getEnums()
        if (enums && enums.content_notes) {
            return enums.content_notes
        } else {
            return []
        }
    },
    processResponse: function (response, callback) {
        const self = this
        try {
            const responseData = response && response.request && response.request.response ? JSON.parse(response.request.response) : {
                success: false,
                data: null,
                message: self.getMessageError(response),
            }
            callback({
                success: responseData ? responseData.success : false,
                data: responseData ? responseData.data : null,
                message: responseData ? responseData.message : null,
            })
        } catch (error) {
            callback({
                success: false,
                message: self.getMessageError(),
            })
        }
    },
    getMessageError: function (response) {
        const str = this.getStrings()
        let messageError = str && str['server_connection_failed'] ? str['server_connection_failed'] : 'Parece que estamos a enfrentar alguns problemas ao estabelecer ligação com o servidor. Por favor, verifica a ligação à internet ou aguarda um pouco antes de tentar novamente.'
        if (response && response.message && response.message !== 'Network Error' && response.code !== 'ECONNABORTED') {
            messageError = response.message
        }
        return messageError
    },
    getAlertOptions: function (args) {
        const str = this.getStrings()
        const strObj = str ? str : {
            'ok': 'Ok',
            'cancel': 'Cancelar'
        }
        const obj = {
            confirmButtonText: strObj['ok'],
            cancelButtonText: strObj['cancel']
        }
        if (args && args.confirmButtonText) {
            obj.confirmButtonText = args.confirmButtonText
        }
        if (args && args.cancelButtonText) {
            obj.cancelButtonText = args.cancelButtonText
        }
        if (args && args.confirmButtonColor === 'warning') {
            obj.confirmButtonColor = '#fb8c00'
        }
        if (args && args.confirmButtonColor === 'success') {
            obj.confirmButtonColor = '#4caf50'
        }
        if (args && args.cancelButtonColor === 'warning') {
            obj.cancelButtonColor = '#fb8c00'
        }
        if (args && args.cancelButtonColor === 'success') {
            obj.cancelButtonColor = '#4caf50'
        }
        return obj
    },
    refreshAppUrl: function () {
        if (window.apiDev) {
            axios.defaults.ptApiUrl = axios.defaults.urls.dev[window.apiKey].base
        }
    },
    getYoutubeEmbedUrl: function (url) {
        if (url.indexOf('/embed/') > -1 ||
            url.indexOf('.imagekit') > -1 ||
            url.indexOf('storageapi.mkgest') > -1 ||
            url.indexOf('.mkgest.') > -1
        ) {
            return url
        }

        let videoId = ''
        let splitId = url.split('v=')[1]

        if (splitId) {
            let ampersandPosition = splitId.indexOf('&')

            if (ampersandPosition != -1) {
                videoId = splitId.substring(0, ampersandPosition)
            } else {
                videoId = splitId
            }
        } else {
            splitId = url.split('.be/')[1]

            if (splitId) {
                videoId = splitId
            }
        }

        if (url.indexOf('/shorts/') > -1) {
            videoId = url.split('/shorts/')[1]
        }

        return 'https://www.youtube.com/embed/' + videoId
    },
    getStrings: function (check) {
        const str = localStorage.getItem('strings')
        return str ? JSON.parse(str) : (check ? null : {})
    },
    setStrings: function (data) {
        localStorage.setItem('strings', JSON.stringify(data))
    },
}
